import { Box, Stack, Tooltip } from '@mui/material';
import React from 'react';
import type { ApplicationChecklist } from '../../data/types';

export const CHECKLIST_LABELS: Record<keyof ApplicationChecklist, string> = {
  entity: 'Entity details',
  owners: 'Beneficial owners',
  identity: 'Identity verification',
  tax: 'TFN and tax residency',
  bank: 'Bank details',
  wholesale: 'Wholesale certificate',
  signed: 'Signed application',
  funds: 'Application monies',
};

const COLOR = { DONE: '#16A34A', PENDING: '#F59E0B', ISSUE: '#DC2626', NA: '#CBD5E1' };

export default function ChecklistDots({ checklist }: { checklist: ApplicationChecklist }) {
  return (
    <Stack direction="row" spacing={0.4} aria-label="Application checklist">
      {(Object.keys(CHECKLIST_LABELS) as (keyof ApplicationChecklist)[]).map((key) => (
        <Tooltip key={key} title={`${CHECKLIST_LABELS[key]}: ${checklist[key].toLowerCase()}`}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: COLOR[checklist[key]] }} />
        </Tooltip>
      ))}
    </Stack>
  );
}
